module.exports = __webpack_public_path__ + "img/file-earmark-spreadsheet.8391ecd6.svg";